module.exports = __webpack_public_path__ + "static/media/estate-car.ed092fe8.png";